import { render, staticRenderFns } from "./ModelX.vue?vue&type=template&id=1e267600&scoped=true&"
import script from "./ModelX.vue?vue&type=script&lang=js&"
export * from "./ModelX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e267600",
  null
  
)

export default component.exports